/** Apple keyboards: ⌘ where others use Ctrl. */
export const isMacLike = () =>
  typeof navigator !== 'undefined' &&
  /Mac|iP(hone|ad|od)/.test(navigator.platform);
